import { type ClaimScope, isFlagInClaimScope } from './isFlagInClaimScope';
import type { ClaimFlagConfiguration } from './types';

const getInScopeEnabledFlags = (
  claimFlagConfigurations: ClaimFlagConfiguration[],
  scope: ClaimScope
): ClaimFlagConfiguration[] =>
  claimFlagConfigurations.filter((flag) => flag.is_enabled && isFlagInClaimScope(flag, scope));

export default getInScopeEnabledFlags;
